import { useFormContext } from 'react-hook-form';

import type { UpdateItemSetQuestionConditionsFormInput } from './schema';

export const useUpdateItemSetQuestionConditionsFormContext =
  useFormContext<UpdateItemSetQuestionConditionsFormInput>;
